import { MoviesCatalogue } from "../../modules/renderMovies";

export default function CatalogueComponent() {
  return <>{MoviesCatalogue()}</>;
}
